import { absoluteURL } from "./UrlHelper";
import { UmbracoFileImageCrop } from "../typings/media-types";

export const isImageUrl = (url: string) =>
{
    return (url.match(/\.(jpeg|jpg|gif|png|svg)(\?|$)/) !== null);
};

export const isVideoUrl = (url: string) =>
{
    return (url.match(/\.(mov|avi|AVI|wmv|WMV|flv|FLV|mpg|MPG|mp4|MP4)$/) !== null);
};

export const isMediaUrl = (url: string) =>
{
    return isImageUrl(url) || isVideoUrl(url);
};

export const getPlaceholderImage = (width: number, height: number) =>
{
    return `https://place-hold.it/${width}x${height}`;
};

/**
 * Get the absolute URL of src with focal points as search params
 */
export const getImageCropUrl = (umbracoFile: UmbracoFileImageCrop | undefined) =>
{
    if (umbracoFile && umbracoFile.src)
    {
        if (umbracoFile.src)
        {
            const imageUrl = new URL(absoluteURL(umbracoFile.src));
            if (umbracoFile?.focalPoint)
            {
                const { left, top } = umbracoFile.focalPoint;
                imageUrl.searchParams.set("center", `${top},${left}`);
            }
            else
            {
                imageUrl.searchParams.set("center", "0.5,0.5");
            }
            return imageUrl.toString();
        }
    }

    return undefined;
};